<template>
  <v-sheet
    class="pr-2"
    elevation="1"
    rounded
    :class="statusColorClass"
  >
    <v-card
      elevation="0"
      tile
      class="mb-4 pa-4"
      style="position: relative;"
    >
      <v-card-title>
        <slot name="title" />

        <v-spacer />

        <slot name="header-actions-prefix" />

        <v-btn
          icon
          @click="collapsed = !collapsed"
        >
          <v-icon>
            {{ collapsableIcon }}
          </v-icon>
        </v-btn>

        <slot name="header-actions-suffix" />
      </v-card-title>
      <v-card-subtitle v-if="$slots.subtitle">
        <slot name="subtitle" />
      </v-card-subtitle>
      <v-card-text>
        <v-expand-transition>
          <div v-if="!collapsed">
            <slot />

            <slot name="overlay">
              <v-overlay
                absolute
                :value="overlay"
                class="text-center"
              >
                <v-progress-circular
                  indeterminate
                  :size="50"
                  color="primary"
                />
                <p class="text-overline white--text mt-4">
                  {{ overlayText }}
                </p>
              </v-overlay>
            </slot>
          </div>
        </v-expand-transition>
      </v-card-text>
      <v-card-actions v-if="$slots.actions">
        <slot name="actions" />
      </v-card-actions>
    </v-card>
  </v-sheet>
</template>

<script>
export default {
  name: 'GenericCollapsableCard',

  props: {
    hasValidation: {
      type: Boolean,
      default: false,
    },

    overlay: {
      type: Boolean,
      default: false,
    },

    overlayText: {
      type: String,
      default: 'Loading...',
    },

    valid: {
      type: Boolean,
      default: true,
    },

  },

  data () {
    return {
      collapsed: false,
    }
  },

  computed: {
    collapsableIcon () {
      return this.collapsed ? 'unfold_more' : 'unfold_less'
    },

    statusColorClass () {
      if (!this.hasValidation) return ''

      if (!this.valid) return 'red'

      return 'light-green'
    },
  },
}
</script>
